
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { mission } = api;

@Component({})
export default class MissionList extends Vue {
  data: {
    data: MissionListViewModel[];
    totalCount: number;
    pageSize: number;
    pageNo: number;
  } = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  loading = false;

  panel = 0;

  headers = [
    { text: '任務分類', value: 'isExternalMission' },
    { text: '標題', value: 'missionName' },
    { text: '達成任務行為', value: 'missionAction' },
    { text: '開始時間', value: 'startOn' },
    { text: '結束時間', value: 'endOn' },
    { text: '啟用', value: 'isEnabled' },
    { text: '編輯', value: 'edit' },
  ];

  isExternalMissions: Array<{ text: string; value: boolean | null }> = [
    { text: '全部', value: null },
    { text: '超級點數任務', value: false },
    { text: '合作任務', value: true },
  ];

  missionActions: Array<{ text: string; value: number | null }> = [
    { text: '全部', value: null },
    { text: '點數換入', value: 1 },
    { text: '兌換商品', value: 2 },
    { text: '線下支付', value: 3 },
    { text: '瀏覽網頁', value: 4 },
  ];

  get totalCount() {
    return this.data.totalCount;
  }

  get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  get collection() {
    return [...(this.data.data || [])];
  }

  filter = {
    isExternalMission: this.$route.query.isExternalMission || null,
    missionAction: this.$route.query.missionAction || null,
    missionName: this.$route.query.missionName || undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query: this.removeEmptyValue(query) });
    }
    await this.requestData();
  }

  async reset() {
    this.filter = {
      isExternalMission: null,
      missionAction: null,
      missionName: undefined,
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  async changeEnableStatus(missionId: string, isEnabled: boolean) {
    const word = isEnabled ? '停用' : '啟用';
    await Swal.fire({
      title: `您確定要${word}嗎?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then(async ({ isConfirmed }) => {
      if (isConfirmed) {
        const { status } = isEnabled
          ? await mission.disable(missionId)
          : await mission.enable(missionId);
        if (status) {
          this.requestData();
        }
      }
    });
  }

  getText<T>(val: T, menu: Array<{ text: string; value: T | null }>) {
    if (val === null || val === undefined) return '全部';
    return menu.find((i) => i.value === val)?.text;
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  async requestData() {
    this.loading = true;
    const { data } = await mission.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private removeEmptyValue(object: any) {
    const newObj: any = {};
    Object.keys(object).forEach((key) => {
      const value = object[key];
      const nullOrEmpty = value === '' || value === undefined || value === null;
      if (!nullOrEmpty) {
        newObj[key] = object[key];
      }
    });
    return newObj;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: MissionList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
